export default __webpack_public_path__ + "static/media/Flag_of_China.97ea1542.svg";